








































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from '@/constants/booking_candidate';
import { STATUSES as SERVICE_REQUEST_STATUSES } from '@/constants/service_request';
import { mapState } from 'vuex';
import QShareCode from '@/components/QShareCode.vue';
import { SERVICE_ITEMS } from '@/constants/service_request';
import _ from 'lodash';
import { STATUSES, BOOKING_PURPOSES } from '@/constants/booking';
import QDownloadBtn from '@/components/QDownloadBtn.vue';
import { changeTextColor } from '@/utils/color';

@Component({
  components: {
    QShareCode,
    QDownloadBtn,
  },
  computed: {
    ...mapState('Booking', {
      booking: 'booking',
    }),
    ...mapState('UserPreference', {
      userPreference: 'single',
    }),
  },
  filters: {
    serviceItemIcon: (value) => {
      return SERVICE_ITEMS[value]?.icon;
    },
  },
  methods: {
    changeTextColor,
  },
})
export default class BookingReadCandidate extends Vue {
  @Prop() readonly item!: Model;
  @Prop() readonly index!: string;

  booking!: Model;
  userPreference!: Model;

  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES;
  serviceRequestStatues = SERVICE_REQUEST_STATUSES;
  isLoading = false;
  statuses = STATUSES;
  showAdditionalService = false;
  bookingPurposes = BOOKING_PURPOSES;

  selectedServiceCandidate = {};

  /**
   * Show the individual status if one of following conditions is true:
   * - the booking is general health check
   * - the userPreference does not exist (It means showing the status by default)
   * - ghc_booking_candidate_status_enabled in userPreference is true
   */
  get showStatus() {
    return (
      (!this.isHealthCheck ||
        !this.userPreference ||
        this.userPreference?.booking_settings
          ?.ghc_booking_candidate_status_enabled) &&
      !this.isBookingCancelled
    );
  }

  get isHealthCheck() {
    return (
      this.booking.purpose ===
      this.bookingPurposes.PURPOSE_HEALTH_CHECK_FOR_CURRENT_EMPLOYEE.key
    );
  }

  get name() {
    if (!this.item.first_name && !this.item.last_name) {
      return null;
    }
    return (this.item.first_name ?? '') + ' ' + (this.item.last_name ?? '');
  }

  get showResult() {
    if (
      this.item.status &&
      !this.isHealthCheck &&
      [this.bookingCandidateStatuses.STATUS_COMPLETED.key].includes(
        this.item.status
      )
    ) {
      return true;
    }
    return false;
  }

  get isBookingComplete() {
    return this.booking.status === this.statuses.STATUS_COMPLETED.key;
  }

  get isBookingCancelled() {
    return this.booking.status === this.statuses.STATUS_CANCELLED.key;
  }

  isServiceAwaitPayment(item) {
    return (
      item.service_request?.status ===
      this.serviceRequestStatues.STATUS_AWAIT_PAYMENT.key
    );
  }

  toDownloadReport() {
    return this.$store
      .dispatch(
        'QuestionnaireAnswer/downloadReport',
        this.item.questionnaire_answer.object_id
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'Quescreen Report - ' + this.name;
        link.click();
      });
  }

  openServiceRequestRead(serviceCandidates, serviceItemOid) {
    const serviceRequest = this.getServiceRequest(
      serviceCandidates,
      serviceItemOid
    );
    console.debug(serviceRequest);
    this.$store.commit(
      'ServiceRequest/SET_ACTIVE_SERVICE_REQUEST',
      serviceRequest
    );
    this.$store.commit('OPEN_DIALOG', {
      open: true,
      content: 'ServiceRequestRead',
      fullscreen: true,
      floater: true,
    });
  }

  openBusinessMessageDialog(serviceCandidates, serviceItemOid) {
    const serviceCandidate = this.getServiceCandidate(
      serviceCandidates,
      serviceItemOid
    );
    this.$store.commit('OPEN_DIALOG', {
      open: true,
      content: 'BusinessMessage',
      selectedServiceCandidate: serviceCandidate,
      fullscreen: false,
      floater: false,
    });
  }

  canUpdateMessage(serviceCandidates, serviceItemOid) {
    const serviceCandidate = this.getServiceCandidate(
      serviceCandidates,
      serviceItemOid
    );
    if (serviceCandidate && _.isEmpty(serviceCandidate.pickup_by)) {
      return true;
    }
    return false;
  }

  getServiceRequest(serviceCandidates, serviceItemOid) {
    if (_.isEmpty(serviceCandidates)) {
      return null;
    }

    const serviceCandidate = this.getServiceCandidate(
      serviceCandidates,
      serviceItemOid
    );
    if (serviceCandidate && serviceCandidate.service_request) {
      return serviceCandidate.service_request;
    } else {
      return null;
    }
  }

  getServiceCandidate(serviceCandidates, serviceItemOid) {
    if (_.isEmpty(serviceCandidates)) {
      return null;
    }

    const serviceCandidate = serviceCandidates.find(
      (item) => item.service_item.object_id === serviceItemOid
    );
    return serviceCandidate;
  }
}
